import { getToken } from '@/utils/auth'

function isAppClient() {
  const userAgent = navigator.userAgent
  return userAgent.includes('Android') || userAgent.includes('Adr') || /\(i[^;]+;( U;)? CPU.+Mac OS X/.test(userAgent)
}

function createAuthError(message) {
  const error = new Error(message)
  error.code = 401
  return error
}

export function waitForAppToken(timeout = 5000) {
  if (!isAppClient()) {
    const token = getToken()
    return token
      ? Promise.resolve(token)
      : Promise.reject(createAuthError('未获取到登录信息'))
  }

  if (window.clinicalAppTokenReady && getToken()) {
    return Promise.resolve(getToken())
  }

  return new Promise((resolve, reject) => {
    let timer
    const cleanup = () => {
      window.removeEventListener('tokenEvent', handleToken)
      if (timer) clearTimeout(timer)
    }
    const handleToken = () => {
      const token = getToken()
      if (!token) return
      cleanup()
      resolve(token)
    }

    window.addEventListener('tokenEvent', handleToken)
    timer = setTimeout(() => {
      cleanup()
      reject(createAuthError('登录信息获取失败'))
    }, timeout)
  })
}

export function isAuthError(error) {
  return Number(error && (error.code || (error.response && error.response.status))) === 401
}
